import { isPlatformBrowser } from '@angular/common';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';

import { OnFeatureInit } from '@frontend/vanilla/core';

import { TracingConfig } from './tracing.client-config';
import { TracingService } from './tracing.service';

@Injectable()
export class TracingBootstrapService implements OnFeatureInit {
    private config = inject(TracingConfig);
    private service = inject(TracingService);

    private isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

    async onFeatureInit() {
        if (this.isBrowser) {
            await this.service.register(this.config.url, this.config.allowedUrlPatterns);
        }
    }
}
